/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Addfilter1Inputs */

const de__filter_addfilter1 = /** @type {(inputs: _Filter_Addfilter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter hinzufügen`)
};

/**

* @param {_Filter_Addfilter1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_addfilter1 = /** @type {((inputs?: _Filter_Addfilter1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Addfilter1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_addfilter1(inputs)
});
export { _filter_addfilter1 as "_filter_addFilter" }